<template>
    <div>
        <div class="site-wrapper no-header">
            <div class="container" v-if="Object.keys(searchResult).length == 0">
                <div class="box">
                    <div class="search-wrapper">
                        <input type="text" class="input" placeholder="Search OffshoreSMS vessel names..." v-model="secureSearchTerm" />
                        <span v-if="attempts > 0" class="tally">{{ attempts }}</span>
                    </div>
                    <div class="spacer s10"></div>
                    <div class="buttons mt-3" v-if="attempts < 5">
                        <button :disabled="secureSearchTerm == ''" class="button is-info" @click="searchAssets()">Search</button>
                        <button v-if="secureSearchTerm != ''" class="button is-light" @click="clearSearch()">Clear</button>
                    </div>
                    <div v-if="attempts < 5">
                        <div v-if="searchResults.length > 0" class="search-results">
                            <hr />
                            <div class="search-result buttons mb-1" v-for="(asset, idx) in searchResults">
                                <span class="button is-light" @click="showAssetInfo(asset)">
                                    <font-awesome-icon icon="plus" />&nbsp;{{ asset.vesselName }}
                                </span>
                            </div>
                        </div>
                        <div v-else>
                            <p v-if="!searching && secureSearchTerm != '' && searchStarted">No assets found. Please try another name search.</p>
                        </div>
                    </div>
                    <div v-else class="red">Too many searches. Please try again later.</div>
                </div>

                <div>OR</div>
                <div class="spacer s10"></div>

                <div class="box">
                    <div class="search-wrapper">
                        <input type="text" class="input" placeholder="Paste a vessel ID" v-model="searchID" />
                    </div>
                    <div class="spacer s10"></div>
                    <div class="buttons mt-3">
                        <button :disabled="searchID == ''" class="button is-info" @click="loadDataByID(searchID)">Search by ID</button>
                        <button v-if="searchID != ''" class="button is-light" @click="clearSearch()">Clear</button>
                    </div>
                    <div>
                        <div v-if="Object.keys(searchResult).length > 0" class="search-results">
                            <hr />
                            <h4>{{ searchResult.vesselName }} data loaded.</h4>
                        </div>
                        <div v-else>
                            <p v-if="!searching && searchID != ''">No vessel found. Please try another ID.</p>
                        </div>
                    </div>
                </div>
                <div class="spacer s10"></div>
            </div>

            <div v-else class="container">
                <div class="box">
                    <h4 class="bold">Asset Data for {{ searchResult.vesselName }}</h4>
                    <p v-if="searchResult.realOwner" class="orange italic">
                        Fleet Owner: {{ searchResult.realOwner.fleetName }} ({{ searchResult.realOwner.location }})
                    </p>
                    <p v-if="searchResult.realOwner" class="orange italic">{{ searchResult.realOwner.fleetID }}</p>
                    <hr />
                    <!-- <pre>{{ searchResult.realOwner }}</pre>
                    <pre>{{ fieldsChanged }}</pre> -->
                    <div class="">
                        <div v-for="(field, idx) in currentUpdateFields">
                            <div v-if="field.type == 'text'">
                                <label class="label bold">{{ field.label }}</label>
                                <input type="text" class="input" v-model="field.value" :placeholder="field.label" @input="field.changed = true" />
                                <div class="spacer s20"></div>
                            </div>
                            <div v-if="field.type == 'bool'">
                                <div class="checkbox-wrapper">
                                    <input
                                        class="is-checkradio"
                                        type="checkbox"
                                        :id="`check-${field.type}-${idx}`"
                                        v-model="field.value"
                                        @change="field.changed = true"
                                    />
                                    <label :for="`check-${field.type}-${idx}`">
                                        {{ field.label }}
                                        <span v-if="field.fieldName == 'isExpired' && field.changed && field.value">
                                            (This will expire the asset)
                                        </span>
                                    </label>
                                </div>
                            </div>
                            <div v-if="field.type == 'checkboxes'">
                                <hr />
                                <label class="label bold">{{ field.label }}</label>
                                <div class="checkbox-wrapper grouped" v-for="(option, oidx) in field.options">
                                    <input
                                        class="is-checkradio"
                                        type="checkbox"
                                        :id="`option-${field.type}-${idx}-${oidx}}`"
                                        :value="option"
                                        v-model="field.value"
                                        @change="field.changed = true"
                                    />
                                    <label :for="`option-${field.type}-${idx}-${oidx}}`">
                                        {{ option }}
                                    </label>
                                </div>
                            </div>
                            <div v-if="field.type == 'dropdown'">
                                <hr />
                                <div class="label bold">{{ field.label }}</div>
                                <div class="select">
                                    <select v-model="field.value" @change="field.changed = true">
                                        <option v-for="(option, oidx) in field.options" :key="oidx" :value="option">
                                            {{ option }}
                                        </option>
                                    </select>
                                </div>
                            </div>

                            <div v-if="field.type == 'datepicker'">
                                <hr />
                                <label class="label bold">{{ field.label }}</label>
                                <div class="form-group" @click="field.changed = true">
                                    <!-- <span>&nbsp;</span> -->
                                    <datetime auto input-id="nextChargeDate" v-model="field.value"></datetime>
                                    <!-- <span class="highlight"></span>
                                    <span class="bar"></span>
                                    <label>{{ field.label }}</label> -->
                                </div>
                                <!-- {{ new Date(field.value) }} -->
                            </div>
                        </div>
                    </div>

                    <hr />
                    <div class="buttons">
                        <span
                            class="button"
                            @click="searchResult.showRaw = !searchResult.showRaw"
                            :class="[searchResult.showRaw ? 'is-danger' : 'is-light']"
                        >
                            <font-awesome-icon :icon="searchResult.showRaw ? 'eye-slash' : 'table'" />&nbsp;{{
                                searchResult.showRaw ? 'Hide' : 'Show'
                            }}
                            Raw Data
                        </span>
                        <button class="button is-skip" :is-loading="updatingAsset == true" @click="updateCurrentAsset(selectedAsset.vesselID)">
                            Update Current Asset
                        </button>
                    </div>
                    <div class="spacer s10"></div>
                    <h4 class="bold blue">Other Actions</h4>
                    <div class="buttons">
                        <span class="button is-light" @click="updateAllCrewWarnings()">Update All Crew Warnings</span>
                    </div>
                    <div class="spacer s10"></div>
                    <div v-if="searchResult.showRaw">
                        <pre>{{ searchResult }}</pre>
                    </div>
                </div>
                <div class="spacer s100"></div>
            </div>
        </div>

        <simple-modal :title="selectedAsset.vesselName" theme="is-primary" submitText="Cancel" @closed="close()" v-if="showAssetModal">
            <div class="basic-info">
                Company Vessel: {{ selectedAsset.isCompanyVessel ? 'YES' : 'No' }}<br />
                Vessel Owner: {{ selectedAsset.vesselOwnerName }}<br />
                Asset ID: {{ selectedAsset.vesselID }}<br />
                Expired? {{ selectedAsset.isExpired ? 'YES' : 'No' }}<br />
            </div>
            <div class="spacer s10"></div>
            <div v-if="!localAssetData[selectedAsset.objectID]" class="buttons">
                <button class="button is-info" @click="loadDataByID(selectedAsset.vesselID)">Load this asset's data</button>
                <button class="button is-skip" :is-loading="updatingAsset" @click="updateCurrentAsset(selectedAsset.vesselID)">
                    Update Current Asset
                </button>
            </div>
            <div v-if="loadingData" class="">
                loading...
            </div>
        </simple-modal>

        <div class="buttons floating">
            <span class="button is-info" @click="$router.go(-1)"><font-awesome-icon icon="chevron-left" /> &nbsp;Back</span>
            <span v-if="Object.keys(searchResult).length > 0" class="button is-warning" @click="clearSearch()">
                <font-awesome-icon icon="redo-alt" /> &nbsp;Reset
            </span>
            <span v-if="hasChanges" class="button is-success" @click="saveUpdates()">
                <font-awesome-icon icon="check-square" /> &nbsp;Save Updates
            </span>
        </div>
    </div>
</template>

<script>
import { db } from '../main.js';
import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/firestore';
import NProgress from 'nprogress';
import algoliasearch from 'algoliasearch';
var searchAlgoliaVessels = firebase.functions().httpsCallable('searchAlgoliaVessels');
var adminRetrieveUserData = firebase.functions().httpsCallable('adminRetrieveUserData');
var cloudSyncCurrentAsset = firebase.functions().httpsCallable('asset_functions-cloudSyncCurrentAsset');
const SimpleModal = () => import('../reusables/SimpleModal.vue');

export default {
    props: {},
    components: {
        SimpleModal
    },
    mounted() {
        this.searchIndex = this.searchClient.initIndex('app_userdata');
    },
    computed: {
        userData() {
            return this.$store.getters.getSubscriptionInfo;
        },
        fieldsChanged() {
            return this.currentUpdateFields.filter(field => field.changed);
        },
        hasChanges() {
            return this.fieldsChanged.length > 0;
        }
    },
    data() {
        return {
            selectedUser: {},
            algoliaClient: algoliasearch('789GF6G7HW', 'd62ebfafa89173cbc6de2f213c30cd75'),
            searchClient: algoliasearch('789GF6G7HW', '0dfd28f6ac249c3ebef88e13f6adbc34'),
            showAssetModal: false,
            isAddingCrew: false,
            selectedAsset: {},
            searchTerm: '',
            loadingData: false,
            currentAssetData: {},
            showCrewDataModal: false,
            currentCrewData: {},
            errorMessage: '',
            secureSearchTerm: '',
            searching: false,
            searchResults: [],
            searchStarted: false,
            attempts: 0,
            localAssetData: {},
            searchID: '',
            searchResult: {},
            currentUpdateFields: [],
            updatingAsset: false
        };
    },
    methods: {
        close() {
            this.showAssetModal = false;
            this.selectedAsset = {};
            this.showCrewDataModal = false;
            this.currentCrewData = {};
            this.isAddingCrew = false;
            this.currentAssetData = {};
            this.searchID = '';
            this.searchResult = {};
            this.currentUpdateFields = [];
            this.updatingAsset = false;
        },
        clearSearch() {
            this.searchResults = [];
            this.searchStarted = false;
            this.secureSearchTerm = '';
            this.searching = false;
            this.searchID = '';
            this.searchResult = {};
            this.currentUpdateFields = [];
        },

        async searchAssets() {
            NProgress.start();
            this.searching = true;
            this.searchStarted = true;
            this.searchResults = [];
            // console.log(this.secureSearchTerm);
            if (this.secureSearchTerm == '') {
                this.searchResults = [];
                this.searching = false;
            } else {
                await searchAlgoliaVessels({
                    searchTerm: this.secureSearchTerm,
                    limit: 10
                }).then(result => {
                    // console.log('result', result.data.text);
                    this.searchResults = result.data.text;
                    this.searching = false;
                });
            }
            NProgress.done();
            this.attempts++;
        },

        // async searchVesselID() {
        //     NProgress.start();
        //     this.searching = true;
        //     await db
        //         .collection('vessels')
        //         .doc(this.searchID)
        //         .get()
        //         .then(doc => {
        //             if (doc.exists) {
        //                 let data = doc.data();
        //                 data.showRaw = false;
        //                 this.searchResult = data;
        //             } else {
        //                 this.searchResult = {};
        //             }
        //         });
        //     this.searching = false;
        //     NProgress.done();
        // },

        async loadRealVesselOwnerData(fleetID) {
            await db
                .collection('companies')
                .doc(fleetID)
                .get()
                .then(doc => {
                    if (doc.exists) {
                        let data = doc.data();
                        this.searchResult.realOwner = {
                            fleetName: data.companyName,
                            fleetID: fleetID,
                            location: data.fleetLocation ? data.fleetLocation : data.companyLocation ? data.companyLocation : ''
                        };
                    }
                });
        },

        async updateCurrentAsset(assetID) {
            console.log('updateCurrentAsset', assetID);
            NProgress.start();
            cloudSyncCurrentAsset({
                assetID: assetID
            });
            setTimeout(() => {
                NProgress.done();
            }, 1000);
        },

        async updateAllCrewWarnings() {
            NProgress.start();
        },

        async loadDataByID(assetID) {
            NProgress.start();
            this.searching = true;
            this.loadingData = true;
            this.showAssetModal = false;
            this.selectedAsset.vesselID = assetID;
            await db
                .collection('vessels')
                .doc(assetID)
                .get()
                .then(async doc => {
                    if (doc.exists) {
                        let data = doc.data();
                        data.showRaw = false;
                        this.searchResult = data;
                        let isCompanyVessel = data.isCompanyVessel ? data.isCompanyVessel : false;
                        let vesselOwnerID = data.vesselOwnerID ? data.vesselOwnerID : '';
                        if (isCompanyVessel && vesselOwnerID != '') await this.loadRealVesselOwnerData(vesselOwnerID);
                        this.currentUpdateFields = [
                            {
                                type: 'text',
                                changed: false,
                                allowEmpty: false,
                                emptyWarning: '',
                                fieldName: 'vesselName',
                                slug: 'vesselname',
                                label: 'Asset Name',
                                value: doc.data().vesselName ? doc.data().vesselName : ''
                            },
                            {
                                type: 'text',
                                changed: false,
                                allowEmpty: false,
                                emptyWarning: '',
                                fieldName: 'vesselUVI',
                                slug: 'vesseluvi',
                                label: 'Unique Identifier (UVI)',
                                value: doc.data().vesselUVI ? doc.data().vesselUVI : ''
                            },
                            {
                                type: 'bool',
                                changed: false,
                                allowEmpty: false,
                                emptyWarning: '',
                                fieldName: 'isExpired',
                                slug: 'isexpired',
                                label: 'Expired',
                                value: doc.data().isExpired ? doc.data().isExpired : false
                            },
                            {
                                type: 'bool',
                                changed: false,
                                allowEmpty: false,
                                emptyWarning: '',
                                fieldName: 'isActive',
                                slug: 'isactive',
                                label: 'Is Active',
                                value: doc.data().isActive ? doc.data().isActive : false
                            },
                            {
                                type: 'bool',
                                changed: false,
                                allowEmpty: false,
                                emptyWarning: '',
                                fieldName: 'isDemo',
                                slug: 'isdemo',
                                label: 'Is Demo',
                                value: doc.data().isDemo ? doc.data().isDemo : false
                            },
                            {
                                type: 'bool',
                                changed: false,
                                allowEmpty: false,
                                emptyWarning: '',
                                fieldName: 'isPrivate',
                                slug: 'isprivate',
                                label: 'Is Private',
                                value: doc.data().isPrivate ? doc.data().isPrivate : false
                            },
                            {
                                type: 'bool',
                                changed: false,
                                allowEmpty: false,
                                emptyWarning: '',
                                fieldName: 'isFreebie',
                                slug: 'isfreebie',
                                label: 'Is Freebie',
                                value: doc.data().isFreebie ? doc.data().isFreebie : false
                            },
                            {
                                type: 'bool',
                                changed: false,
                                allowEmpty: false,
                                emptyWarning: '',
                                fieldName: 'isPaidFor',
                                slug: 'ispaidfor',
                                label: 'Is Paid For',
                                value: doc.data().isPaidFor ? doc.data().isPaidFor : false
                            },
                            {
                                type: 'bool',
                                changed: false,
                                allowEmpty: false,
                                emptyWarning: '',
                                fieldName: 'isProTrips',
                                slug: 'isprotrips',
                                label: 'Is Pro Trips',
                                value: doc.data().isProTrips ? doc.data().isProTrips : false
                            },
                            {
                                type: 'bool',
                                changed: false,
                                allowEmpty: false,
                                emptyWarning: '',
                                fieldName: 'parentFleetIsEnterprise',
                                slug: 'parentfleetisenterprise',
                                label: 'Parent is Enterprise',
                                value: doc.data().parentFleetIsEnterprise ? doc.data().parentFleetIsEnterprise : false
                            },
                            {
                                type: 'bool',
                                changed: false,
                                allowEmpty: false,
                                emptyWarning: '',
                                fieldName: 'hasShipsLogChecklists',
                                slug: 'hasShipsLogChecklists',
                                label: 'Ships Log Checklists',
                                value: doc.data().hasShipsLogChecklists ? doc.data().hasShipsLogChecklists : false
                            },
                            {
                                type: 'dropdown',
                                changed: false,
                                allowEmpty: false,
                                emptyWarning: '',
                                fieldName: 'nextRenewalStatus',
                                slug: 'nextrenewalstatus',
                                label: 'Next Renewal Status',
                                value: doc.data().nextRenewalStatus ? doc.data().nextRenewalStatus : 'manual',
                                options: ['manual', 'auto', 'none']
                            },
                            {
                                type: 'checkboxes',
                                changed: false,
                                allowEmpty: false,
                                emptyWarning: '',
                                fieldName: 'aaaPlans',
                                slug: 'aaaplans',
                                label: 'AAA Plans',
                                value: doc.data().aaaPlans ? doc.data().aaaPlans : ['logs'],
                                options: ['logs', 'sms', 'pro', 'ops']
                            },
                            // {
                            //     type: 'checkboxes',
                            //     changed: false,
                            //     allowEmpty: false,
                            //     emptyWarning: '',
                            //     fieldName: 'billingData.modules',
                            //     slug: 'billingdatamodules',
                            //     label: 'Billing Modules',
                            //     value: doc.data().billingData && doc.data().billingData.modules ? doc.data().billingData.modules : ['free'],
                            //     options: ['free', 'crew', 'maint', 'sms', 'forms', 'trips', 'ops']
                            // },
                            {
                                type: 'dropdown',
                                changed: false,
                                allowEmpty: false,
                                emptyWarning: '',
                                fieldName: 'assetType',
                                slug: 'assettype',
                                label: 'Asset Type',
                                value: doc.data().assetType ? doc.data().assetType : 'vessel',
                                options: ['vessel', 'vehicle', 'premises', 'structure', 'system', 'group']
                            },
                            {
                                type: 'datepicker',
                                changed: false,
                                allowEmpty: false,
                                emptyWarning: '',
                                fieldName: 'nextChargeDate',
                                slug: 'nextchargedate',
                                label: 'Next Charge Date',
                                value: doc.data().nextChargeDate
                                    ? doc
                                          .data()
                                          .nextChargeDate.toDate()
                                          .toISOString()
                                    : new Date().setDate(new Date().getDate() + 7),
                                options: []
                            }
                        ];
                    } else {
                        this.searchResult = {};
                    }
                });
            this.searching = false;
            this.loadingData = false;
            NProgress.done();
        },

        async saveUpdates() {
            NProgress.start();
            let updates = {};
            this.fieldsChanged.forEach(field => {
                if (field.type == 'checkboxes') {
                    updates[field.fieldName] = field.value;
                } else if (field.type == 'bool') {
                    updates[field.fieldName] = field.value;
                } else if (field.type == 'datepicker') {
                    updates[field.fieldName] = new Date(field.value);
                } else {
                    updates[field.fieldName] = field.value;
                }
            });
            console.log('updates', updates, this.selectedAsset.vesselID);
            if (!this.selectedAsset.vesselID) {
                console.log('No vessel ID found. Cannot save updates.');
                return;
            } else {
                await db
                    .collection('vessels')
                    .doc(this.selectedAsset.vesselID)
                    .update(updates)
                    .then(() => {
                        this.currentUpdateFields.forEach(field => {
                            field.changed = false;
                        });
                    });
                this.close();
            }
            NProgress.done();
        },

        // async loadAssetData() {
        //     let self = this;
        //     NProgress.start();
        //     this.showAssetModal = false;
        //     if (this.localAssetData[this.selectedAsset.objectID]) {
        //         this.currentAssetData = this.localAssetData[this.selectedAsset.objectID];
        //     } else {
        //         this.loadingData = true;
        //         await db
        //             .collection('vessels')
        //             .doc(this.selectedAsset.vesselID)
        //             .get()
        //             .then(doc => {
        //                 if (doc.exists) {
        //                     console.log('doc', doc.data());
        //                     let data = doc.data();
        //                     data.showRaw = false;
        //                     self.searchResult = data;
        //                     self.currentAssetData = data;
        //                     self.currentUpdateFields = [
        //                         // { type: 'text', changed: false, allowEmpty: false, emptyWarning: '',fieldName: 'vesselName', label: 'Vessel Name', value: doc.data().vesselName },
        //                         {
        //                             type: 'text',
        //                             changed: false,
        //                             allowEmpty: false,
        //                             emptyWarning: '',
        //                             fieldName: 'vesselUVI',
        //                             label: 'Vessel UVI',
        //                             value: doc.data().vesselUVI
        //                         },
        //                         {
        //                             type: 'bool',
        //                             changed: false,
        //                             allowEmpty: false,
        //                             emptyWarning: '',
        //                             fieldName: 'isExpired',
        //                             label: 'Expired',
        //                             value: doc.data().isExpired ? doc.data().isExpired : false
        //                         },
        //                         {
        //                             type: 'bool',
        //                             changed: false,
        //                             allowEmpty: false,
        //                             emptyWarning: '',
        //                             fieldName: 'isActive',
        //                             label: 'Is Active',
        //                             value: doc.data().isActive ? doc.data().isActive : false
        //                         },
        //                         {
        //                             type: 'bool',
        //                             changed: false,
        //                             allowEmpty: false,
        //                             emptyWarning: '',
        //                             fieldName: 'isDemo',
        //                             label: 'Is Demo',
        //                             value: doc.data().isDemo ? doc.data().isDemo : false
        //                         },
        //                         {
        //                             type: 'bool',
        //                             changed: false,
        //                             allowEmpty: false,
        //                             emptyWarning: '',
        //                             fieldName: 'isPrivate',
        //                             label: 'Is Private',
        //                             value: doc.data().isPrivate ? doc.data().isPrivate : false
        //                         },
        //                         {
        //                             type: 'bool',
        //                             changed: false,
        //                             allowEmpty: false,
        //                             emptyWarning: '',
        //                             fieldName: 'isFreebie',
        //                             label: 'Is Freebie',
        //                             value: doc.data().isFreebie ? doc.data().isFreebie : false
        //                         },
        //                         {
        //                             type: 'bool',
        //                             changed: false,
        //                             allowEmpty: false,
        //                             emptyWarning: '',
        //                             fieldName: 'isPaidFor',
        //                             label: 'Is Paid For',
        //                             value: doc.data().isPaidFor ? doc.data().isPaidFor : false
        //                         },
        //                         {
        //                             type: 'bool',
        //                             changed: false,
        //                             allowEmpty: false,
        //                             emptyWarning: '',
        //                             fieldName: 'isProTrips',
        //                             label: 'Is Pro Trips',
        //                             value: doc.data().isProTrips ? doc.data().isProTrips : false
        //                         },
        //                         {
        //                             type: 'bool',
        //                             changed: false,
        //                             allowEmpty: false,
        //                             emptyWarning: '',
        //                             fieldName: 'parentFleetIsEnterprise',
        //                             label: 'Parent is Enterprise',
        //                             value: doc.data().parentFleetIsEnterprise ? doc.data().parentFleetIsEnterprise : false
        //                         },
        //                         {
        //                             type: 'checkboxes',
        //                             changed: false,
        //                             allowEmpty: false,
        //                             emptyWarning: '',
        //                             fieldName: 'aaaPlans',
        //                             label: 'AAA Plans',
        //                             value: doc.data().aaaPlans ? doc.data().aaaPlans : ['logs'],
        //                             options: ['logs', 'sms', 'pro', 'ops']
        //                         },
        //                         {
        //                             type: 'checkboxes',
        //                             changed: false,
        //                             allowEmpty: false,
        //                             emptyWarning: '',
        //                             fieldName: 'billingData.modules',
        //                             label: 'Billing Modules',
        //                             value: doc.data().billingData && doc.data().billingData.modules ? doc.data().billingData.modules : ['free'],
        //                             options: ['free', 'crew', 'maint', 'sms', 'forms', 'trips', 'ops']
        //                         },
        //                         {
        //                             type: 'dropdown',
        //                             changed: false,
        //                             allowEmpty: false,
        //                             emptyWarning: '',
        //                             fieldName: 'assetType',
        //                             label: 'Asset Type',
        //                             value: doc.data().assetType ? doc.data().assetType : 'vessel',
        //                             options: ['vessel', 'vehicle', 'premises', 'structure', 'system', 'group']
        //                         }
        //                     ];
        //                 } else {
        //                     console.log('No vessel found!');
        //                     self.searchResult = {};
        //                 }
        //                 this.loadingData = false;
        //                 NProgress.done();
        //             })
        //             .catch(error => {
        //                 console.log('error', error);
        //                 this.loadingData = false;
        //             });
        //     }
        // },

        maskPhone(num) {
            return 'Ends in "' + num.substring(num.length - 3) + '"';
        },

        maskEmail(email) {
            let start = email.substring(0, 1);
            let domain = email.substring(email.lastIndexOf('@') + 1);
            return start + '------@' + domain;
        },

        showAssetInfo(item) {
            console.log(item);
            this.selectedAsset = item;
            this.showAssetModal = true;
        },

        makeLetters(displayName) {
            let res = displayName.split(' ');
            if (res.length > 1) {
                return res[0].substring(0, 1) + res[1].substring(0, 1);
            } else {
                return res[0].substring(0, 1);
            }
        },

        async updateCurrentUser() {
            NProgress.start();
            console.log(this.localAssetData[this.selectedAsset.objectID]);
            await db
                .collection('userdata')
                .doc(this.localAssetData[this.selectedAsset.objectID].userdata.userid)
                .update({
                    showQuickNote: this.localAssetData[this.selectedAsset.objectID].userdata.showQuickNote
                })
                .then(() => {
                    NProgress.done();
                    this.close();
                });
        }
    }
};
</script>

<style lang="scss" scoped>
.message {
    .message-body {
        background: #fff;
    }
}
textarea {
    min-height: 100px !important;
    box-shadow: none;
    padding: 0.6rem 1rem;
    &.notes {
        margin-top: 1rem;
    }
}
input[type='text'] {
    padding: 15px 20px;
    height: auto;
}
.search-panel__results {
    .searchbox.ais-SearchBox {
        input[type='search'] {
            padding: 35px 20px;
            &.search-input-override {
                height: 4rem;
            }
        }
    }
    ol {
        margin-left: 2rem;
    }
}
.search-panel {
    display: flex;
}

.search-panel__filters {
    flex: 1;
    margin-right: 1em;
}

.search-panel__results {
    flex: 3;
}

.searchbox {
    margin-bottom: 1rem;
    color: red;
}
.ais-SearchBox-form {
    height: 4rem !important;
}
// .ais-SearchBox {
//     input[type='text'] {
//         max-height: none;
//         height: auto;
//         padding: 2rem;
//     }
//     .ais-SearchBox-form {
//         .MySearchBoxInput {
//             max-height: none;
//             height: auto;
//             padding: 2rem;
//         }
//     }
// }
// .ais-SearchBox-input,
// .MySearchBoxInput {
//     max-height: none;
//     height: auto;
//     padding: 2rem;
// }
// .MySearchBox {
//     color: yellow;
//     .MySearchBoxForm {
//         font-size: 2rem;
//         .MySearchBoxInput {
//             border-color: red;
//         }
//     }
// }
.MySearchBox {
    margin-bottom: 1rem;
}

.search-wrapper {
    position: relative;
    .tally {
        position: absolute;
        border-radius: 50%;
        top: 5px;
        right: 5px;
        background: red;
        color: white;
        width: 21px;
        height: 21px;
        font-size: 0.8rem;
        display: flex;
        justify-content: center;
        align-items: center;
    }
}

.crew-data {
    margin-bottom: 6px;
    span {
        font-weight: bold;
        width: 180px;
        display: inline-block;
    }
}
.search-result-user {
    display: flex;
    align-items: center;
    cursor: pointer;
    .search-avatar {
        margin-right: 9px;
        transition: 0.25s;
    }
    .search-name {
        font-size: 1rem;
        color: cadetblue;
        transition: 0.25s;
    }
    &:hover {
        .search-avatar {
            transform: scale(1.1);
        }
        .search-name {
            color: orange;
        }
    }
}
.checkbox-wrapper {
    margin: 15px 0;
}
</style>
